<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
  </div>
  <div class="modal-body">
    <div class="container">
      <form class="forms-sample d-flex flex-column" [formGroup]="form">
        <div class="col-12 row">
          <div class="col-12 mb-3" *ngIf="!isApprove">
            <label class="form-label col-md-12 align-self-center">เหตุผล</label>
            <textarea class="form-control" rows="2" cols="2" formControlName="approveReason"
                      [ngClass]="{'is-invalid': isFormInvalid('approveReason')}" placeholder="-- โปรดระบุ --"></textarea>
          </div>
          <div class="col-md-6 col-12">
            <label class="form-label col-md-12 align-self-center">วันที่ทำรายการ</label>
            <input type="text" class="form-control" placeholder="-- โปรดระบุ --" formControlName="approveDate"
                   [ngClass]="{'is-invalid': isFormInvalid('approveDate')}"
                   bsDatepicker [bsConfig]="{ dateInputFormat: 'DD MMMM YYYY' }" />
          </div>
          <div class="col-md-6 col-12">
            <label class="form-label col-md-12 align-self-center">ผู้อนุมัติ</label>
            <input type="text" class="form-control" placeholder="-- โปรดระบุ --" formControlName="approveByName"
                   [ngClass]="{'is-invalid': isFormInvalid('approveByName')}" />
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success me-3" (click)="confirm()" *ngIf="isApprove">
      <i class="feather icon-check-circle"></i> อนุมัติ
    </button>
    <button type="button" class="btn btn-danger" (click)="confirm()" *ngIf="!isApprove">
      <i class="feather icon-x-circle"></i> ปฏิเสธ
    </button>
  </div>
</div>
